// src/v3/account/approved.tsx
import { createSvgIcon } from "@mui/material";
import { jsx, jsxs } from "react/jsx-runtime";
var ApprovedIcon = createSvgIcon(
  /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      children: [
        /* @__PURE__ */ jsx("circle", { cx: "11.75", cy: "11.75", r: "9.75", fill: "currentColor" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "white",
            d: "M15.5916 9.25457c.0626.06251.1122.13674.1461.21845.0339.08171.0513.1693.0513.25775 0 .08845-.0174.17604-.0513.25775-.0339.08168-.0835.15598-.1461.21848l-4.7115 4.7115c-.0626.0626-.1368.1122-.2185.1461-.0817.0339-.1693.0513-.2578.0513-.0884 0-.176-.0174-.2577-.0513s-.15594-.0835-.21845-.1461l-2.01923-2.0192c-.1263-.1263-.19725-.2976-.19725-.4762 0-.1786.07095-.3499.19725-.4762.12629-.1263.29759-.1973.4762-.1973s.3499.071.4762.1973l1.54298 1.5438 4.2354-4.23613c.0625-.06258.1367-.11223.2184-.1461.0817-.03387.1693-.05131.2578-.05131.0884 0 .176.01744.2577.05131s.156.08352.2185.1461ZM20.5 11.75c0 1.7306-.5132 3.4223-1.4746 4.8612-.9615 1.439-2.3281 2.5605-3.9269 3.2227-1.5989.6623-3.3582.8356-5.0555.498-1.69737-.3377-3.25647-1.171-4.48018-2.3947-1.22371-1.2237-2.05707-2.7828-2.39469-4.4802-.33762-1.6973-.16434-3.4566.49793-5.05548.66226-1.59885 1.78377-2.96542 3.2227-3.92688C8.32769 3.51318 10.0194 3 11.75 3c2.3199.00245 4.5441.92511 6.1845 2.56552C19.5749 7.20593 20.4976 9.43011 20.5 11.75Zm-1.3462 0c0-1.4643-.4342-2.8958-1.2477-4.11336-.8136-1.21755-1.9699-2.16652-3.3228-2.7269-1.3528-.56038-2.8415-.707-4.2777-.42132-1.43622.28568-2.75546.99082-3.79091 2.02627C5.47925 7.55014 4.7741 8.86937 4.48842 10.3056c-.28568 1.4362-.13906 2.9249.42132 4.2777.56038 1.3529 1.50935 2.5092 2.72691 3.3228 1.21755.8135 2.64905 1.2477 4.11335 1.2477 1.9629-.0022 3.8448-.7829 5.2329-2.171 1.388-1.388 2.1687-3.2699 2.1709-5.2328Z"
          }
        )
      ]
    }
  ),
  "ApprovedIcon"
);

export {
  ApprovedIcon
};
